window.addEventListener('load', () => {
  adjustMainPadding({ mobile: true, desktop: true });
  window.addEventListener('resize', () => adjustMainPadding({ mobile: true, desktop: true }));
});

function adjustMainPadding({ mobile = true, desktop = true } = {}) {
  const header = document.querySelector('custom-header.header');
  const main = document.querySelector('main#main');
  if (!header || !main) return;

  const isMobile = window.matchMedia('(max-width: 767px)').matches;

  if ((isMobile && !mobile) || (!isMobile && !desktop)) {
    main.style.paddingTop = '';
    return;
  }

  main.style.paddingTop = `${header.offsetHeight}px`;
}

(function () {
  const $ = (s, c = document) => c.querySelector(s);

  // ---- Cart-Section minimal neu ziehen & ersetzen ----
  function getCartSectionId() {
    // Deine ID ist z. B. "template--25436489711941__cart"
    const host = $('#form-cart')?.closest('.shopify-section');
    return host?.id?.replace('shopify-section-', '') || null;
  }

  async function refreshCartSection() {
    const sid = getCartSectionId();
    if (!sid) return;
    const res = await fetch(`${location.pathname}?sections=${encodeURIComponent(sid)}`, { credentials: 'same-origin' });
    if (!res.ok) return;
    const html = (await res.json())[sid];
    if (!html) return;

    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const fresh = tmp.querySelector(`#shopify-section-${sid}`);
    const live  = document.getElementById(`shopify-section-${sid}`);
    if (fresh && live) live.replaceWith(fresh);
  }

  // ---- Badge: erstellen falls fehlend + data-hidden toggeln ----
  const CART_BADGE_ANCHOR = '.nav-item--cart > a';

  // ---- Add-to-Cart: Button außerhalb des Formulars ----
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('product-form .btn-cart');
    if (!btn) return;
    if (location.pathname.replace(/\/+$/, '') !== '/cart') return;

    const form = btn.closest('product-form')?.querySelector('form[action="/cart/add"]');
    if (!form) return;

    // >>> WICHTIG: Doppel-Submit verhindern
    if (btn.dataset.processing === 'true') return;
    btn.dataset.processing = 'true';

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin',
      });
      if (!res.ok) return;

      await refreshCartSection();
      await updateCartBadge();
    } finally {
      delete btn.dataset.processing;
    }
  }, true);

  // ---- Quantity + / - ----
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.btn-quantity');
    if (!btn) return;

    // WICHTIG: Nur auf /cart eingreifen, sonst Produktseiten in Ruhe lassen
    if (location.pathname.replace(/\/+$/, '') !== '/cart') return;

    // Lock: schnelles Doppelklicken abfangen
    if (btn.dataset.processing === 'true') return;
    btn.dataset.processing = 'true';

    const wrap  = btn.closest('.quantity-wrapper');
    const input = wrap?.querySelector('.input-quantity');
    if (!input) { delete btn.dataset.processing; return; }

    const id = input.dataset.id;                 
    const cur = parseInt(input.value, 10) || 0;
    const delta = btn.dataset.action === 'add' ? 1 : -1;
    const next = Math.max(0, cur + delta);

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity: next }),
        credentials: 'same-origin',
      });
      if (!res.ok) return;

      await refreshCartSection();
      await updateCartBadge();
    } finally {
      delete btn.dataset.processing;
    }
  }, true);
})();

// 1) Einmal oben definieren (Selector ggf. an dein Theme anpassen)
const CART_BADGE_SELECTOR = '.cart-count';

async function updateCartBadge() {
  try {
    const cart = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
    const n = Number(cart.item_count) || 0;

    document.querySelectorAll(CART_BADGE_SELECTOR).forEach((el) => {
      el.textContent = String(n);
      // unterstützt sowohl hidden als auch data-hidden
      if ('hidden' in el) el.hidden = n === 0;
      el.setAttribute('data-hidden', n === 0 ? 'true' : 'false');
    });

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  } catch (e) {
    console.warn('[cart] badge update failed', e);
  }
}
function formatiereAlkoholgehalt() {
  document.querySelectorAll('p strong').forEach(function(label) {
    if (label.textContent.trim().toUpperCase() !== 'ALKOHOLGEHALT:') return;

    const textNode = label.nextSibling;
    if (!textNode || textNode.nodeType !== 3) return;

    textNode.textContent = textNode.textContent.replace(
      /(\d+(?:[.,]\d+)?)(?=\s*%\s*Vol\.)/i,
      function(match) {
        const wert = Number(match.replace(',', '.'));
        return Number.isFinite(wert)
          ? String(wert).replace('.', ',')
          : match;
      }
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', formatiereAlkoholgehalt);
} else {
  formatiereAlkoholgehalt();
}